import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  PawIcon, ScissorsIcon, SparklesIcon, CheckIcon,
} from "./Icons";

/* ── Extra icons needed only in Services ────────────────────────────────── */
const DogIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M7 11v1.5a5 5 0 0 0 10 0V11"/>
    <path d="M17 11A5 5 0 0 0 7 11"/>
    <path d="M7 8c-2 0-4 1.5-4 4s1.5 4 2.5 4 2.5-1.5 2.5-3"/>
    <path d="M17 8c2 0 4 1.5 4 4s-1.5 4-2.5 4-2.5-1.5-2.5-3"/>
    <path d="M12 14v1"/>
    <path d="M11 14h2"/>
    <path d="M10 10.5v.5"/>
    <path d="M14 10.5v.5"/>
  </svg>
);

const CatIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5z"/>
    <path d="M8 14v.5"/>
    <path d="M16 14v.5"/>
    <path d="M11.25 16.25h1.5L12 17l-.75-.75z"/>
  </svg>
);

const BedIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M2 4v16"/>
    <path d="M2 8h18a2 2 0 0 1 2 2v10"/>
    <path d="M2 17h20"/>
    <path d="M6 8v9"/>
  </svg>
);

const HomeIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const SunIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const ToothIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M12 5.5c-1.5-2-4-2.5-5.5-1C4.5 6 4 8.5 5 10.5c.6 1.2.8 2.5.5 4L5 18c-.2 1 .5 2 1.5 2s1.8-.8 2-1.8l.3-1.4c.2-.8.9-1.3 1.7-1.2.7.1 1.3.6 1.5 1.2l.3 1.4c.2 1 1 1.8 2 1.8s1.7-1 1.5-2l-.5-3.5c-.3-1.5-.1-2.8.5-4 1-2 .5-4.5-1.5-6C13.2 2.9 13 3 12 5.5z"/>
  </svg>
);

const EyeIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EarIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 0 1-7 0"/>
    <path d="M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"/>
  </svg>
);

const PillIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z"/>
    <line x1="8.5" y1="8.5" x2="15.5" y2="15.5"/>
  </svg>
);

const InfoIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

const PlusCircleIcon = (p) => (
  <svg width={p.size||20} height={p.size||20} viewBox="0 0 24 24" fill="none"
    stroke={p.color||"currentColor"} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={p.style}>
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="16"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);

/* ── Section header subcomponent ─────────────────────────────────────────── */
const SectionHeader = ({ id, Icon, title, subtitle, gradient }) => (
  <div id={id} className="text-center mb-12 scroll-mt-24">
    <div className={`inline-flex items-center gap-2 text-sm font-bold px-4 py-1.5 rounded-full mb-4 ${gradient} text-white shadow-lg`}>
      <Icon size={16} color="white" /> {subtitle}
    </div>
    <h2 className="text-4xl md:text-5xl font-bold text-gray-800">{title}</h2>
  </div>
);

/* ── Default fallback data ────────────────────────────────────────────────── */
const DEFAULT_SERVICES = {
  grooming: {
    dog: [
      { name: "Basic Grooming", sizes: [
        { label: "Small",       sub: "Single Coated", price: 400 },
        { label: "Medium",      sub: "Single Coated", price: 500 },
        { label: "Large",       sub: "Double Coated", price: 650 },
        { label: "Extra Large", sub: "Triple Coated", price: 850 },
      ]},
      { name: "Full Grooming", sizes: [
        { label: "Small",       sub: "Single Coated", price: 500 },
        { label: "Medium",      sub: "Single Coated", price: 600 },
        { label: "Large",       sub: "Double Coated", price: 750 },
        { label: "Extra Large", sub: "Triple Coated", price: 950 },
      ]},
    ],
    cat:    [{ name: "Cat Grooming", price: 600, description: "Full bath, blow dry & brush out" }],
    addons: [
      { name: "Nail Trim",      price: 100 },
      { name: "Teeth Brushing", price: 100 },
      { name: "Eye Wash",       price: 100 },
      { name: "Ear Cleaning",   price: 100 },
      { name: "Anal Drain",     price: 180 },
    ],
  },
  hotel: [
    { name: "Dog Room Small",  price: 500, description: "Overnight stay",         icon: "dog_small" },
    { name: "Dog Room Large",  price: 800, description: "Spacious overnight stay", icon: "dog_large" },
    { name: "Cat Villa Small", price: 500, description: "Cozy overnight villa",    icon: "cat_villa" },
    { name: "Cat Villa Large", price: 800, description: "Spacious luxury villa",   icon: "cat_villa" },
    { name: "Day Care",        price: 200, description: "First 3 hours",           icon: "sun"       },
  ],
};

const getAddonIcon = (name = "") => {
  const lower = name.toLowerCase();
  if (lower.includes("nail"))  return ScissorsIcon;
  if (lower.includes("teeth")) return ToothIcon;
  if (lower.includes("eye"))   return EyeIcon;
  if (lower.includes("ear"))   return EarIcon;
  if (lower.includes("anal"))  return PillIcon;
  return PlusCircleIcon;
};

const getHotelIcon = (name = "", icon = "") => {
  const key = (icon + name).toLowerCase();
  if (key.includes("cat"))   return HomeIcon;
  if (key.includes("large")) return HomeIcon;
  if (key.includes("day") || key.includes("sun")) return SunIcon;
  return BedIcon;
};

const fmtPrice = (p) => p != null ? `₱${Number(p).toLocaleString()}` : "—";

/* Extract clean size name and coat type badge */
const formatDogSize = (item) => {
  const rawLabel = item.label || "";
  const lower = rawLabel.toLowerCase();
  
  let label = rawLabel;
  let coat = "";

  if (lower.includes("extra large") || lower.includes("xl") || lower.includes("triple")) {
    label = "Extra Large";
    coat = "Triple Coated";
  } else if (lower.includes("large") || lower.includes("double")) {
    label = "Large";
    coat = "Double Coated";
  } else if (lower.includes("medium")) {
    label = "Medium";
    coat = "Single Coated";
  } else if (lower.includes("small")) {
    label = "Small";
    coat = "Single Coated";
  }

  const sub = item.sub || coat || item.description || "";
  return { label, coat, sub };
};

const COAT_TYPES_GUIDE = [
  {
    type: "Single Coated",
    badge: "1 Layer • Smooth & Silky",
    sizes: "Small & Medium Sizes",
    icon: "✨",
    bgCard: "bg-purple-50/70 border-purple-200",
    pillColor: "bg-purple-100 text-purple-700 border-purple-200",
    badgeColor: "bg-purple-600 text-white",
    description: "Dogs with only a single layer of fur and no thick undercoat. The hair either grows continuously (like human hair) or stays short and sleek.",
    features: [
      "No dense insulating undercoat",
      "Lower shedding & easier brush-out",
      "Faster bathing & blow-drying time"
    ],
    breeds: ["Shih Tzu", "Poodle", "Maltese", "Yorkshire Terrier", "Bichon Frise", "French Bulldog", "Chihuahua", "Pug", "Dachshund"]
  },
  {
    type: "Double Coated",
    badge: "2 Layers • Guard Coat + Dense Undercoat",
    sizes: "Large Sizes",
    icon: "🐕",
    bgCard: "bg-blue-50/70 border-blue-200",
    pillColor: "bg-blue-100 text-blue-700 border-blue-200",
    badgeColor: "bg-blue-600 text-white",
    description: "Dogs with two distinct coat layers: a weather-resistant topcoat (guard hairs) and a dense, woolly undercoat for insulation that sheds seasonally.",
    features: [
      "Dense, plush insulating undercoat",
      "Seasonal heavy shedding & blowout required",
      "Specialized de-shedding & line-brushing needed"
    ],
    breeds: ["Golden Retriever", "Siberian Husky", "Labrador", "German Shepherd", "Corgi", "Pomeranian", "Shiba Inu", "Beagle", "Australian Shepherd"]
  },
  {
    type: "Triple Coated",
    badge: "3 Heavy Layers • Massive Dense Fur",
    sizes: "Extra Large (XL) Sizes",
    icon: "🦁",
    bgCard: "bg-pink-50/70 border-pink-200",
    pillColor: "bg-pink-100 text-pink-700 border-pink-200",
    badgeColor: "bg-fuchsia-600 text-white",
    description: "Dogs with exceptionally thick, voluminous, heavy-density coats with massive undercoat volume designed for cold climates.",
    features: [
      "Maximum fur density & heavy undercoat mass",
      "Requires intensive high-velocity blowout & de-matting",
      "Extended grooming time & specialized deep conditioning"
    ],
    breeds: ["Chow Chow", "Samoyed", "Alaskan Malamute", "Saint Bernard", "Newfoundland", "Great Pyrenees", "Tibetan Mastiff", "Bernese Mountain Dog"]
  }
];

const getBreedExamples = (label = "", coat = "") => {
  const l = (label || "").toLowerCase();
  const c = (coat || "").toLowerCase();
  if (c.includes("triple") || l.includes("extra large") || l.includes("xl")) {
    return "Chow Chow, Samoyed, Malamute, St. Bernard";
  }
  if (c.includes("double") || l.includes("large")) {
    return "Golden Retriever, Husky, German Shepherd, Corgi";
  }
  if (l.includes("medium")) {
    return "French Bulldog, Beagle, Cocker Spaniel";
  }
  return "Shih Tzu, Poodle, Yorkie, Chihuahua";
};

/* ── Main component ───────────────────────────────────────────────────────── */
const Services = ({ setActiveTab, serviceSection, setServiceSection }) => {
  const [services, setServices] = useState(null); // null = loading
  const [loadError, setLoadError] = useState(false);

  /* Fetch live prices from DB */
  useEffect(() => {
    let ok = true;
    axios.get("/api/services")
      .then(res => {
        if (!ok) return;
        if (res.data.success && res.data.data) setServices(res.data.data);
        else { setServices(DEFAULT_SERVICES); setLoadError(true); }
      })
      .catch(() => { if (ok) { setServices(DEFAULT_SERVICES); setLoadError(true); } });
    return () => { ok = false; };
  }, []);

  useEffect(() => {
    if (!serviceSection) return;
    const idMap = {
      "dog-grooming": "section-dog-grooming",
      "cat-grooming": "section-cat-grooming",
      "boarding":     "section-boarding",
      "daycare":      "section-boarding",
    };
    const targetId = idMap[serviceSection];
    if (targetId) {
      setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
    setServiceSection(null);
  }, [serviceSection, setServiceSection]);

  if (!services) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="w-12 h-12 rounded-full border-4 border-purple-200 border-t-purple-600 animate-spin" />
      <p className="text-gray-400 font-semibold text-sm">Loading prices…</p>
    </div>
  );

  const data = services;
  const catMain    = data.grooming?.cat    || [];
  const catAddons  = data.grooming?.addons || [];
  const hotelRooms = data.hotel            || [];

  const basicIncludes = ["Bath & Blow Dry", "Nail Trimming", "Ear Cleaning", "Basic Brush Out"];
  const fullIncludes  = [...basicIncludes, "Haircut & Styling", "Cologne Spritz", "Bandana / Bow"];

  return (
    <div className="min-h-screen overflow-x-hidden">

      {/* ── PAGE HERO ── */}
      <div className="relative overflow-hidden py-20 px-6 text-center">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-600 via-fuchsia-600 to-pink-600" />
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-0 w-72 h-72 bg-white/5 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-72 h-72 bg-white/5 rounded-full blur-3xl" />
        </div>

        {/* Floating SVG decorations */}
        {[ScissorsIcon, PawIcon, PawIcon, ScissorsIcon].map((Icon, i) => (
          <div key={i} className={i % 2 === 0 ? "animate-float-slow" : "animate-float-med"}
            style={{
              position: "absolute",
              top: i < 2 ? `${8 + i * 16}%` : "auto",
              bottom: i >= 2 ? `${8 + (i - 2) * 12}%` : "auto",
              left: i % 2 === 0 ? `${10 + i * 3}%` : "auto",
              right: i % 2 !== 0 ? `${10 + i * 2}%` : "auto",
              opacity: 0.25,
              color: "white",
              pointerEvents: "none",
            }}>
            <Icon size={28} color="white" />
          </div>
        ))}

        <div className="relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Services &amp; Pricing
          </h1>
          <p className="text-white/80 text-lg max-w-xl mx-auto flex items-center justify-center gap-2">
            Premium care for every fur baby — transparent pricing, no hidden fees.
            <PawIcon size={18} color="rgba(255,255,255,0.7)" />
          </p>
          {loadError && (
            <p className="mt-3 text-yellow-200 text-xs font-semibold">
              ⚠️ Showing default prices (could not reach server)
            </p>
          )}
        </div>
      </div>

      <div className="container mx-auto px-6 py-16 max-w-6xl space-y-24">

        {/* ── DOG GROOMING ── */}
        <section>
          <SectionHeader
            id="section-dog-grooming"
            Icon={DogIcon}
            subtitle="Dog Grooming"
            title="Grooming Packages"
            gradient="bg-gradient-to-r from-purple-500 to-fuchsia-500"
          />

          {/* ── GROOMING POLICY NOTICES ── */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            {/* Tick & Flea Notice */}
            <div className="flex-1 flex items-start gap-3 bg-red-50 border border-red-200 rounded-2xl p-4">
              <span className="text-2xl shrink-0">🚫</span>
              <div>
                <p className="text-red-700 font-bold text-sm mb-0.5">No Ticks or Fleas Policy</p>
                <p className="text-red-600 text-xs leading-relaxed">
                  For the safety of all pets in our care, <strong>pets must be free of ticks and fleas</strong> before their grooming session. Pets found to have an active infestation will not be accepted for grooming until treated.
                </p>
              </div>
            </div>
            {/* Toothbrush Notice */}
            <div className="flex-1 flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-2xl p-4">
              <span className="text-2xl shrink-0">🪥</span>
              <div>
                <p className="text-amber-700 font-bold text-sm mb-0.5">Bring Your Own Toothbrush</p>
                <p className="text-amber-600 text-xs leading-relaxed">
                  Please bring your pet's own toothbrush for the Teeth Brushing add-on. If you don't have one, a toothbrush can be provided at the clinic for an <strong>additional fee</strong>.
                </p>
              </div>
            </div>
          </div>

          {/* Dynamically Map All Dog Grooming Packages */}
          {(data.grooming?.dog || []).map((dogPkg, pkgIdx) => {
            const isFull = dogPkg.name?.toLowerCase().includes("full");
            const textColor = isFull ? "text-pink-600" : "text-purple-600";
            const bgBadgeColor = isFull ? "bg-pink-50 border-pink-100" : "bg-purple-50 border-purple-100";
            const lineBorderColor = isFull ? "bg-pink-100" : "bg-purple-100";
            const cardBgGradient = isFull ? "from-pink-50 to-rose-50 border-pink-100" : "from-purple-50 to-fuchsia-50 border-purple-100";
            const badgeTagColor = isFull ? "text-pink-700 bg-pink-100 border-pink-200" : "text-purple-700 bg-purple-100 border-purple-200";
            const priceGradient = isFull ? "from-pink-500 to-rose-500" : "from-purple-600 to-fuchsia-600";
            const pkgIncludes = isFull ? fullIncludes : basicIncludes;

            return (
              <div key={dogPkg._id || pkgIdx} className={pkgIdx > 0 ? "mt-12" : "mb-10"}>
                <div className="flex items-center gap-3 mb-6">
                  <div className={`h-px flex-1 ${lineBorderColor}`} />
                  <span className={`flex items-center gap-2 ${textColor} font-bold text-lg px-4 py-1 ${bgBadgeColor} rounded-full border`}>
                    {isFull ? <SparklesIcon size={16} color="#db2777" /> : <PawIcon size={16} color="#9333EA" />} {dogPkg.name}
                  </span>
                  <div className={`h-px flex-1 ${lineBorderColor}`} />
                </div>

                {dogPkg.description && (
                  <p className="text-center text-gray-500 text-xs sm:text-sm max-w-xl mx-auto -mt-2 mb-6">
                    {dogPkg.description}
                  </p>
                )}

                <div className="flex flex-wrap justify-center gap-2 mb-8">
                  {pkgIncludes.map((item, i) => (
                    <span key={i} className={`flex items-center gap-1.5 ${bgBadgeColor} text-gray-700 text-sm font-semibold px-3 py-1.5 rounded-full border`}>
                      <CheckIcon size={13} color="#22c55e" strokeWidth={2.5} /> {item}
                    </span>
                  ))}
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                  {(dogPkg?.sizes || []).map((item, i) => {
                    const sizeInfo = formatDogSize(item);
                    return (
                      <div key={i} className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl border border-purple-100 hover:border-purple-300 transition-all duration-300 transform hover:-translate-y-2 overflow-hidden flex flex-col justify-between">
                        <div className={`bg-gradient-to-br ${cardBgGradient} p-5 text-center border-b flex flex-col items-center justify-center`}>
                          <div className="flex justify-center">
                            {isFull ? <SparklesIcon size={44} color="#db2777" /> : <DogIcon size={44} color="#9333EA" />}
                          </div>
                          <h3 className="font-bold text-gray-800 text-lg mt-3">{sizeInfo.label}</h3>
                          {sizeInfo.coat && (
                            <div className="mt-2">
                              <span className={`inline-block px-3 py-1 text-xs font-black rounded-full border shadow-sm ${badgeTagColor}`}>
                                {sizeInfo.coat}
                              </span>
                            </div>
                          )}
                          <p className="text-[11px] text-gray-500 font-medium mt-2.5 px-1 leading-snug">
                            <span className="text-gray-400">e.g. </span>{getBreedExamples(sizeInfo.label, sizeInfo.coat)}
                          </p>
                        </div>
                        <div className="p-5 text-center">
                          <div className={`text-3xl font-bold bg-gradient-to-r ${priceGradient} bg-clip-text text-transparent`}>
                            {fmtPrice(item.price)}
                          </div>
                          <p className="text-xs text-gray-400 mt-1">per session</p>
                          <a
                            href="#coat-type-guide"
                            onClick={(e) => {
                              e.preventDefault();
                              const el = document.getElementById("coat-type-guide");
                              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                            }}
                            className="inline-flex items-center gap-1 text-[11px] font-bold text-purple-600 hover:text-purple-800 hover:underline mt-2.5"
                          >
                            <span>ℹ️</span> What coat is my dog?
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}

          {/* ── COAT TYPE & SIZING GUIDE ── */}
          <div id="coat-type-guide" className="mt-16 bg-white/80 backdrop-blur-xl rounded-[2.5rem] p-6 md:p-10 border border-purple-100 shadow-xl scroll-mt-24">
            <div className="text-center max-w-2xl mx-auto mb-10">
              <div className="inline-flex items-center gap-2 text-xs font-bold px-3.5 py-1.5 rounded-full bg-purple-100 text-purple-700 border border-purple-200 mb-3">
                <PawIcon size={14} color="#7E22CE" /> Understanding Coat Types &amp; Pricing
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-800 mb-3">
                Dog Coat Type &amp; Sizing Guide
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Why do grooming prices differ by coat type? Thicker, multi-layered coats require specialized de-shedding rakes, higher blow-drying time, and intensive care. Check our guide below to find your fur baby's category:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {COAT_TYPES_GUIDE.map((coat, idx) => (
                <div
                  key={idx}
                  className={`rounded-3xl p-6 border-2 flex flex-col justify-between transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${coat.bgCard}`}
                >
                  <div>
                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-3xl p-2 bg-white rounded-2xl shadow-sm border border-gray-100">{coat.icon}</span>
                      <span className={`text-[11px] font-bold px-3 py-1 rounded-full ${coat.badgeColor} shadow-sm`}>
                        {coat.sizes}
                      </span>
                    </div>

                    <h4 className="text-xl font-black text-gray-800 mb-1">{coat.type}</h4>
                    <span className={`inline-block text-[11px] font-bold px-2.5 py-0.5 rounded-lg border mb-3 ${coat.pillColor}`}>
                      {coat.badge}
                    </span>

                    <p className="text-gray-600 text-xs leading-relaxed mb-4 font-medium">
                      {coat.description}
                    </p>

                    {/* Features list */}
                    <ul className="space-y-1.5 mb-5 text-xs text-gray-700 font-medium">
                      {coat.features.map((feat, fIdx) => (
                        <li key={fIdx} className="flex items-start gap-1.5">
                          <CheckIcon size={13} color="#9333EA" strokeWidth={2.5} className="shrink-0 mt-0.5" />
                          <span>{feat}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Popular Breeds */}
                  <div className="pt-4 border-t border-purple-200/60">
                    <p className="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-2">Common Breeds:</p>
                    <div className="flex flex-wrap gap-1.5">
                      {coat.breeds.map((b, bIdx) => (
                        <span key={bIdx} className="text-[10px] font-bold px-2 py-0.5 bg-white/90 text-gray-700 rounded-md border border-gray-200 shadow-2xs">
                          {b}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Reassurance banner */}
            <div className="mt-8 p-4 bg-gradient-to-r from-purple-50 via-pink-50 to-amber-50 border border-purple-100 rounded-2xl flex items-center gap-3.5 text-xs text-gray-700">
              <span className="text-2xl shrink-0">💡</span>
              <div>
                <strong className="text-purple-800">Not sure which coat type your pet has?</strong>
                <p className="text-gray-600 mt-0.5">
                  No worries! Our professional groomers always examine your pet's size, weight, and coat density upon check-in at the clinic to confirm the exact best package for them.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ── CAT GROOMING ── */}
        <section>
          <SectionHeader
            id="section-cat-grooming"
            Icon={CatIcon}
            subtitle="Cat Services"
            title="Cat Grooming"
            gradient="bg-gradient-to-r from-orange-400 to-amber-500"
          />

          {/* Cat main */}
          <div className="mb-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px flex-1 bg-orange-100" />
              <span className="flex items-center gap-2 text-orange-600 font-bold text-lg px-4 py-1 bg-orange-50 rounded-full border border-orange-100">
                <CatIcon size={16} color="#ea580c" /> Cat Grooming
              </span>
              <div className="h-px flex-1 bg-orange-100" />
            </div>
            <div className="max-w-sm mx-auto flex flex-col gap-4">
              {catMain.map((item, i) => (
                <div key={i} className="group flex items-center gap-4 bg-white rounded-3xl shadow-lg hover:shadow-2xl border border-orange-100 hover:border-orange-300 p-5 transition-all duration-300 transform hover:-translate-y-1">
                  <div className="w-14 h-14 flex-shrink-0 bg-gradient-to-br from-orange-100 to-amber-100 rounded-2xl flex items-center justify-center shadow-sm">
                    <CatIcon size={30} color="#ea580c" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-gray-800 text-lg leading-tight">{item.name || "Cat Grooming"}</h3>
                    <p className="text-gray-400 text-xs mt-0.5">{item.description || "Full bath, blow dry & brush out"}</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <div className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent">
                      {fmtPrice(item.price)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── ADD-ONS ── */}
        <section>
          <SectionHeader
            id="section-addons"
            Icon={PlusCircleIcon}
            subtitle="Extra Services"
            title="Add-ons"
            gradient="bg-gradient-to-r from-yellow-400 to-amber-500"
          />

          {/* Add-ons */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px flex-1 bg-amber-100" />
              <span className="flex items-center gap-2 text-amber-600 font-bold text-lg px-4 py-1 bg-amber-50 rounded-full border border-amber-100">
                <PlusCircleIcon size={16} color="#d97706" /> Add-ons (Dogs & Cats)
              </span>
              <div className="h-px flex-1 bg-amber-100" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {catAddons.map((item, i) => {
                const AddonIcon = getAddonIcon(item.name);
                return (
                  <div key={i} className="group flex items-center gap-4 bg-white rounded-3xl shadow-lg hover:shadow-2xl border border-amber-100 hover:border-amber-300 p-5 transition-all duration-300 transform hover:-translate-y-1">
                    <div className="w-14 h-14 flex-shrink-0 bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl flex items-center justify-center shadow-sm">
                      <AddonIcon size={26} color="#d97706" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-gray-800 text-lg leading-tight">{item.name}</h3>
                      <p className="text-gray-400 text-xs mt-0.5">{item.description || ""}</p>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <div className="text-2xl font-bold bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">
                        {fmtPrice(item.price)}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── PET HOTEL / BOARDING ── */}
        <section>
          <SectionHeader
            id="section-boarding"
            Icon={BedIcon}
            subtitle="Boarding & Daycare"
            title="Pet Hotel & Daycare"
            gradient="bg-gradient-to-r from-teal-500 to-emerald-500"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {hotelRooms.map((item, i) => {
              const HotelIcon = getHotelIcon(item.name, item.icon || "");
              const isLarge = (item.name || "").toLowerCase().includes("large");
              return (
              <div key={i} className={`relative group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl border transition-all duration-300 transform hover:-translate-y-2 ${isLarge ? "border-teal-400 ring-2 ring-teal-300/40" : "border-teal-100 hover:border-teal-300"}`}>
                {isLarge && (
                  <div className="absolute top-3 right-3 flex items-center gap-1 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow">
                    <SparklesIcon size={10} color="white" /> Popular
                  </div>
                )}
                <div className={`p-5 text-center border-b ${isLarge ? "bg-gradient-to-br from-teal-50 to-emerald-50 border-teal-100" : "bg-gradient-to-br from-gray-50 to-teal-50/30 border-teal-100/60"}`}>
                  <div className="flex justify-center">
                    <HotelIcon size={42} color="#0d9488" />
                  </div>
                  <h3 className="font-bold text-gray-800 text-lg mt-3 leading-tight">{item.name}</h3>
                  <p className="text-gray-400 text-xs mt-0.5">{item.description || "Overnight stay"}</p>
                </div>
                <div className="p-5 text-center bg-white">
                  <div className="text-3xl font-bold bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
                    {fmtPrice(item.price)}
                  </div>
                  <p className="text-xs text-gray-400 mt-1">per night</p>
                </div>
              </div>
              );
            })}
          </div>

          {/* Info note */}
          <div className="mt-8 bg-teal-50 border border-teal-100 rounded-2xl p-5 flex items-start gap-3 max-w-2xl mx-auto">
            <div className="flex-shrink-0 mt-0.5">
              <InfoIcon size={22} color="#0d9488" />
            </div>
            <p className="text-teal-800 text-sm leading-relaxed">
              <strong>Strict Vaccination Requirement:</strong> Dogs and cats that are not vaccinated will <strong>NOT be accepted in the store</strong>. Please bring or upload your pet's updated vaccination card (including Anti-Rabies) on or before check-in. Our staff is available 24/7 during hotel stays.
            </p>
          </div>
        </section>

        {/* ── BOOK CTA ── */}
        <section className="text-center pb-8">
          <div className="bg-gradient-to-br from-purple-600 via-fuchsia-600 to-pink-600 rounded-3xl p-12 shadow-2xl relative overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 left-0 w-48 h-48 bg-white/5 rounded-full blur-2xl" />
              <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full blur-2xl" />
            </div>
            <div className="relative z-10 space-y-4">
              <div className="flex justify-center animate-float-med">
                <PawIcon size={52} color="rgba(255,255,255,0.7)" />
              </div>
              <h3 className="text-3xl font-bold text-white">Ready to book?</h3>
              <p className="text-white/75 text-lg">Give your pet the premium care they deserve.</p>
              <button
                onClick={() => setActiveTab("booking")}
                className="inline-flex items-center gap-2 bg-white text-purple-700 px-10 py-4 rounded-2xl text-lg font-bold shadow-xl hover:shadow-white/30 transform hover:scale-105 transition-all duration-300"
              >
                Book Appointment Now <PawIcon size={20} color="#7C3AED" />
              </button>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Services;
